/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LinkedChatroomControllerFindLinkedChatroomsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 고객(서비스) ID */
    hserviceID: string;
    /** 연동된 채팅방 */
    chatRoomID: {
      title: string;
      roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** 수정자 userID */
    modifierID?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 삭제 일시
     * @format date
     */
    removedAt?: string;
    /** 연동된 채널명 */
    channelName: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LinkedChatroomElUnlinkHandlerBodyRequest {
  _id?: string;
}

export interface LinkedChatroomElUnlinkHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 서비스 ID */
    hserviceID: string;
    /** 채팅방 ID */
    chatRoomID: {
      title: string;
      roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** 수정자 userID */
    modifierID?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 삭제 일시
     * @format date
     */
    removedAt?: string;
    /** 연동된 채널명 */
    channelName: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LinkedChatroomElUnlinkByChatroomHandlerBodyRequest {
  hserviceID?: string;
  chatRoomID?: string;
}

export interface LinkedChatroomElUnlinkByChatroomHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 서비스 ID */
    hserviceID: string;
    /** 채팅방 ID */
    chatRoomID: {
      title: string;
      roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** 수정자 userID */
    modifierID?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 삭제 일시
     * @format date
     */
    removedAt?: string;
    /** 연동된 채널명 */
    channelName: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LinkedChatroomControllerFindLinkedChatroomsParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 고객(서비스) ID */
  hserviceID?: string;
  /**
   * 연동 해제 여부로 걸러낸다. 주지 않으면 해제된 기록까지 함께 나온다 (boolean string: true/false)
   * @example "false"
   */
  isRemoved?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: string;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type LinkedChatroomControllerFindLinkedChatroomsData = LinkedChatroomControllerFindLinkedChatroomsResponse;

export type LinkedChatroomElUnlinkHandlerData = LinkedChatroomElUnlinkHandlerResponse;

export type LinkedChatroomElUnlinkByChatroomHandlerData = LinkedChatroomElUnlinkByChatroomHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 고객에게 연동된 채널 채팅방 목록을 채널명과 함께 조회한다. 채팅방 문서가 사라진 연동은 결과에서 제외된다.
     *
     * @tags V3-LinkedChatroom
     * @name LinkedChatroomControllerFindLinkedChatrooms
     * @summary 연동된 채팅방 목록 조회
     * @request GET:/v3/api/linkedchatrooms/find
     * @secure
     * @response `200` `LinkedChatroomControllerFindLinkedChatroomsData` success
     */
    linkedChatroomControllerFindLinkedChatrooms: (
      query: LinkedChatroomControllerFindLinkedChatroomsParams,
      params: RequestParams = {},
    ) =>
      this.request<LinkedChatroomControllerFindLinkedChatroomsData, any>({
        path: `/v3/api/linkedchatrooms/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 연동된 채팅방 연결 해제
     *
     * @tags V3-LinkedChatroom
     * @name LinkedChatroomElUnlinkHandler
     * @summary 연동된 채팅방 연결 해제
     * @request PATCH:/v3/api/linkedchatrooms/el/unlink
     * @secure
     * @response `200` `LinkedChatroomElUnlinkHandlerData` success
     */
    linkedChatroomElUnlinkHandler: (data: LinkedChatroomElUnlinkHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<LinkedChatroomElUnlinkHandlerData, any>({
        path: `/v3/api/linkedchatrooms/el/unlink`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 연동된 채팅방 연결 해제 - 채팅방, 환자 ID 기준
     *
     * @tags V3-LinkedChatroom
     * @name LinkedChatroomElUnlinkByChatroomHandler
     * @summary 연동된 채팅방 연결 해제 - 채팅방, 환자 ID 기준
     * @request PATCH:/v3/api/linkedchatrooms/el/unlink-by-chatroom
     * @secure
     * @response `200` `LinkedChatroomElUnlinkByChatroomHandlerData` success
     */
    linkedChatroomElUnlinkByChatroomHandler: (
      data: LinkedChatroomElUnlinkByChatroomHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<LinkedChatroomElUnlinkByChatroomHandlerData, any>({
        path: `/v3/api/linkedchatrooms/el/unlink-by-chatroom`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
